import BaseService from '@/services/BaseService';

class LoginService extends BaseService {
    loginFirstStep = (data) => this.post('/login', data);

    loginSecondStep = (data) => this.post('/verify-2fa-otp', data);

    loginResendOtp = (data) => this.post('/resend-2fa-otp', data);

    logout = () => this.get('/logout');
}

export default new LoginService();
